import { render, staticRenderFns } from "./central_suppression_check.config.vue?vue&type=template&id=ee0182ec"
import script from "./central_suppression_check.config.vue?vue&type=script&lang=js"
export * from "./central_suppression_check.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports